import { Card, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {IcJacket, IcShirt, IcTrouser, IcUser, ILWelcome } from '../../assets/img';
import { TotalProduct } from "../../components";
import { getDataJacket, getDataTrouser, getDataUser, getShirt } from "../../config/Redux/action";

const Dashboard = () => {
    const dispatch = useDispatch();
    const [shirts, setShirts] = useState([]);
    const [trousers, setTrousers] = useState([]);
    const [jackets, setJackets] = useState([]);
    const [users, setUsers] = useState([]);
    useEffect(() => {
    const getData = async () => {
        const resShirt = await dispatch(getShirt());
        setShirts(resShirt);
        const resTrouser = await dispatch(getDataTrouser());
        setTrousers(resTrouser);
        const resJacket = await dispatch(getDataJacket());
        setJackets(resJacket);
        const resUser = await dispatch(getDataUser());
        setUsers(resUser);
    };
    getData();
    }, [dispatch]);
    const totalShirt = shirts.filter(
    (shirt) => shirt.data.publish === 'published',
    );
    const totalTrouser = trousers.filter(
    (trouser) => trouser.data.publish === 'published',
    );
    const totalJacket = jackets.filter(
    (jacket) => jacket.data.publish === 'published',
    );
    return (
      <div id='dashboard'>
        <Row gutter={42}>
          <Col span={6}>
            <TotalProduct
              title={'Shirt'}
              image={IcShirt}
              length={totalShirt.length}
            />
          </Col>
          <Col span={6}>
            <TotalProduct
              title={'Trouser'}
              image={IcTrouser}
              length={totalTrouser.length}
            />
          </Col>
          <Col span={6}>
            <TotalProduct
              title={'Jacket'}
              image={IcJacket}
              length={totalJacket.length}
            />
          </Col>
          <Col span={6}>
            <TotalProduct title={'User'} image={IcUser} length={users.length} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Card
              className={'card'}
              style={{display:'flex', justifyContent:'center' }}
            >
              <img
                src={ILWelcome}
                width={700}
                alt='Gambar Welcome'
              />
            </Card>
          </Col>
        </Row>
      </div>
    );
}

export default Dashboard